import React from 'react';
import { Link } from 'react-router-dom';
import './PrivacyPolicy.css';
import logo from './logo.png';
import { MdArrowBack } from 'react-icons/md';

function TermsOfService() {
	return (
		<div className="privacy-page">
			<header className="privacy-header">
				<div className="privacy-header-inner">
					<img src={logo} alt="mestprogramma logo" className="privacy-logo" />
					<h1>Gebruikersvoorwaarden</h1>
					<p className="privacy-subtitle">mestprogramma.be</p>
				</div>
			</header>

			<div className="privacy-content">
				<Link to="/" className="back-link">
					<MdArrowBack size={20} />
					<span>Terug naar hoofdpagina</span>
				</Link>

				<section className="privacy-section">
					<p className="intro-text">
						Welkom bij Mestprogramma. Door gebruik te maken van onze applicatie gaat u akkoord met deze gebruikersvoorwaarden. Lees deze voorwaarden zorgvuldig door voordat u de applicatie gebruikt.
					</p>
				</section>

				<section className="privacy-section">
					<h2>Artikel 1: Definities</h2>
					<ul className="privacy-list">
						<li><strong>Applicatie:</strong> De web-applicatie beschikbaar via mestprogramma.be</li>
						<li><strong>Gebruiker:</strong> Iedere natuurlijke of rechtspersoon die gebruik maakt van de Applicatie</li>
						<li><strong>Ontwikkelaar:</strong> Mestprogramma, gevestigd te Leuven</li>
						<li><strong>Diensten:</strong> Alle functionaliteiten en services aangeboden via de Applicatie</li>
					</ul>
				</section>

				<section className="privacy-section">
					<h2>Artikel 2: Gebruik van de Applicatie</h2>
					<div className="info-box highlight">
						<p>
							<strong>Belangrijk:</strong> De web-applicatie is uitsluitend bedoeld als simulatie- en planningstool. De berekeningen zijn gebaseerd op de door de gebruiker verstrekte gegevens en de op dat moment geldende (bekende) normen.
						</p>
					</div>
					<p>
						De gebruiker erkent dat de berekeningen complex zijn en dat de resultaten enkel als indicatief moeten worden beschouwd. De applicatie vervangt nimmer het professionele oordeel van de landbouwer of een officieel erkend mestvoerder.
					</p>
				</section>

				<section className="privacy-section">
					<h2>Artikel 3: Informatieve aard</h2>
					<p>
						De informatie en berekeningen die via de Applicatie worden verstrekt, zijn uitsluitend informatief van aard. De Applicatie is bedoeld als hulpmiddel bij de planning en het beheer van meststromen, maar vervangt niet de officiële regelgeving of professioneel advies.
					</p>
					<p>
						De gebruiker dient zich altijd te baseren op de officiële communicatie van de Mestbank en de Vlaamse Landmaatschappij (VLM) voor definitieve beslissingen.
					</p>
				</section>

				<section className="privacy-section">
					<h2>Artikel 4: Aansprakelijkheid</h2>
					<p>
						Hoewel de uiterste zorg wordt besteed aan de juistheid van de berekeningen, garandeert de ontwikkelaar niet dat de software foutloos of ononderbroken zal functioneren.
					</p>
					<div className="info-box">
						<p>
							<strong>Uitsluiting van boetes:</strong> De ontwikkelaar is in geen enkel geval aansprakelijk voor boetes, sancties of naheffingen opgelegd door de Mestbank, de Vlaamse Landmaatschappij (VLM) of enige andere overheidsinstantie naar aanleiding van het gebruik van de output van deze applicatie.
						</p>
					</div>
					<p>
						De gebruiker is zelf verantwoordelijk voor het verifiëren van de gegenereerde PDF-rapporten voordat deze voor officiële doeleinden worden gebruikt.
					</p>
					<p>
						De totale aansprakelijkheid van de ontwikkelaar is beperkt tot het bedrag dat de gebruiker heeft betaald voor het gebruik van de applicatie in de afgelopen 6 maanden, met een absoluut maximum van €100.
					</p>
				</section>

				<section className="privacy-section">
					<h2>Artikel 5: Eigen verantwoordelijkheid gebruiker</h2>
					<p>
						De eindgebruiker is verplicht de logica van de output te controleren. Indien resultaten onwaarschijnlijk of onlogisch lijken (bijvoorbeeld extreme bemestingsruimte), dient de gebruiker:
					</p>
					<ul className="privacy-list">
						<li>Contact op te nemen met de ontwikkelaar via <a href="mailto:info@mestprogramma.be">info@mestprogramma.be</a></li>
						<li>De resultaten niet te gebruiken voor bemestingsdoeleinden totdat de oorzaak is achterhaald</li>
						<li>De ingevoerde gegevens te controleren op juistheid</li>
					</ul>
				</section>

				<section className="privacy-section">
					<h2>Artikel 6: Intellectueel eigendom</h2>
					<p>
						Alle intellectuele eigendomsrechten met betrekking tot de Applicatie, inclusief maar niet beperkt tot software, ontwerp, teksten en logo's, berusten bij de Ontwikkelaar.
					</p>
					<p>
						Het is de gebruiker niet toegestaan om zonder voorafgaande schriftelijke toestemming van de Ontwikkelaar de Applicatie of onderdelen daarvan te kopiëren, te wijzigen, te distribueren of te reverse-engineeren.
					</p>
				</section>

				<section className="privacy-section">
					<h2>Artikel 7: Beschikbaarheid</h2>
					<p>
						De Ontwikkelaar streeft naar een optimale beschikbaarheid van de Applicatie, maar kan geen 100% uptime garanderen. Onderhoud, updates of technische storingen kunnen leiden tot tijdelijke onbeschikbaarheid.
					</p>
					<p>
						De Ontwikkelaar is niet aansprakelijk voor schade als gevolg van de onbeschikbaarheid van de Applicatie.
					</p>
				</section>

				<section className="privacy-section">
					<h2>Artikel 8: Wijzigingen</h2>
					<p>
						De Ontwikkelaar behoudt zich het recht voor om deze gebruikersvoorwaarden te allen tijde te wijzigen. Wijzigingen worden van kracht zodra deze op de website zijn gepubliceerd.
					</p>
					<p>
						Bij substantiële wijzigingen zal de Ontwikkelaar redelijke inspanningen leveren om gebruikers hiervan op de hoogte te stellen.
					</p>
				</section>

				<section className="privacy-section">
					<h2>Artikel 9: Toepasselijk recht</h2>
					<p>
						Op deze gebruikersvoorwaarden en het gebruik van de Applicatie is Belgisch recht van toepassing. Geschillen die voortvloeien uit of verband houden met deze voorwaarden zullen worden voorgelegd aan de bevoegde rechtbank te Leuven.
					</p>
				</section>

				<section className="privacy-section">
					<h2>Contact</h2>
					<div className="info-box">
						<p><strong>Website:</strong> <a href="https://mestprogramma.be">https://mestprogramma.be</a></p>
						<p><strong>E-mail:</strong> <a href="mailto:info@mestprogramma.be">info@mestprogramma.be</a></p>
						<p><strong>Locatie:</strong> Leuven</p>
					</div>
				</section>

				<div className="privacy-footer-info">
					<p className="last-updated">Laatst bijgewerkt: {new Date().getFullYear()}</p>
				</div>
			</div>

			<footer className="privacy-footer">
				<div className="privacy-footer-inner">
					<div className="footer-left">&copy; {new Date().getFullYear()} mestprogramma</div>
					<div className="footer-right">
						Contact: <a href="mailto:info@mestprogramma.be" className="contact-email">info@mestprogramma.be</a>
					</div>
				</div>
			</footer>
		</div>
	);
}

export default TermsOfService;
